import Apis from 'Src/const/apis'
import { isSupported } from './tool'

// 直播间白名单
const isLiveAdvertiser = isSupported(GLOBAL_VAR.liveAdvertiser)

const CODE_SUCCESS = 0
const DEFAULT_ERROR_MSG = '系统错误'
const DEFAULT_TIMEOUT = 5e3

/**
 * 根据 app_id 查询建站小程序数据，默认不区分类型且过滤禁用 && 下线状态。用途有：
 * - 验证小程序是否来自建站
 * - 获取建站小程序类型等建站维度的字段
 * @param {Number} appID 小程序 app_id
 * @param {Object} params 查询参数
 * @returns {Promise<never>|Promise<unknown>}
 */
export const fetchOrangeMicroAppInfoById = (appID, params = {}) => {
  if (!appID) return Promise.reject(new Error(DEFAULT_ERROR_MSG))
  return new Promise((resolve, reject) => {
    const _reject = (msg = DEFAULT_ERROR_MSG) => {
      reject(new Error(msg))
    }
    const data = {
      app_ids: JSON.stringify([appID]),
      order_mode: 1,
      type_list: '[0,1]',
      page: 1,
      page_size: 8,
      ...params
    }
    window.BUI.fetch({
      url: Apis.microApp.getOrangeList,
      data,
      success: ({ code, data, msg }) => {
        if (code === CODE_SUCCESS && data && data.list && data.list[0] && data.list[0].app_id === appID) {
          resolve(data.list[0])
        } else {
          _reject(msg)
        }
      },
      error: ({ msg }) => {
        _reject(msg)
      }
    })
  })
}

export const fetchConvertGoals = params => {
  if (_.isEmpty(params)) return Promise.resolve([])
  return new Promise((resolve, reject) => {
    window.BUI.update({
      url: Apis.ad.getConvertGoals,
      data: JSON.stringify(params),
      contentType: 'application/json',
      timeout: DEFAULT_TIMEOUT,
      success: ({ code, data }) => {
        if (code === 0) {
          resolve(data)
        } else {
          resolve([])
        }
      },
      error: () => {
        reject(new Error(DEFAULT_ERROR_MSG))
      }
    })
  })
}

/**
 * 根据 转化目标 convert_id 获取转化目标详情
 * @param {Number} convertId 转化目标 convert_id 列表
 * @returns {Promise<never>|Promise<unknown>}
 */
export const fetchConvertDetailByConvertId = convertId => {
  if (!convertId) return Promise.reject(new Error(DEFAULT_ERROR_MSG))
  return new Promise((resolve, reject) => {
    const _reject = (msg = DEFAULT_ERROR_MSG) => reject(new Error(msg))
    const data = {
      convert_id: String(convertId)
    }
    window.BUI.fetch({
      url: Apis.ad.getConvertDetail,
      data,
      success: ({ code, data, msg }) => {
        if (code === CODE_SUCCESS && data) {
          resolve(data)
        } else {
          _reject(msg)
        }
      },
      error: ({ msg }) => {
        _reject(msg)
      }
    })
  })
}

/**
 * 检查低风险行业，默认 false
 * @returns {Promise<unknown>}
 */
export const checkIsLowRisk = () => new Promise(resolve =>
  window.BUI.fetch({
    url: Apis.ad.low_risk_indsutry,
    success: ({ code, data }) => {
      resolve(Boolean(code === CODE_SUCCESS && data && data.is_low_risk_industry))
    },
    error: () => { resolve(false) }
  })
)

/**
 * 检查是否支持直播间推广目的：非黑名单（默认 true） && ( 低风险行业（默认 false） || 直播白名单 175 )
 * @returns {Promise<unknown>}
 */
export const checkIsSupportLive = () => new Promise(resolve =>
  window.BUI.fetch({
    url: Apis.ad.is_advertiser_allowable,
    data: {
      advertiser_id: GLOBAL_VAR && GLOBAL_VAR.advertiser && GLOBAL_VAR.advertiser.id
    },
    success: ({ code, data }) => {
      if (code === CODE_SUCCESS && data && data.allowable) {
        resolve(isLiveAdvertiser || checkIsLowRisk())
      } else {
        resolve(false)
      }
    },
    error: () => { resolve(isLiveAdvertiser || checkIsLowRisk()) }
  })
)
